export default __webpack_public_path__ + "static/cashflow_new_8-44897ef2b0a313faff0ce1cd20b2eb0a.jpg";